import React, { Component } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected"; 
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { CATEGORY_COLOR_SET } from '../../../../config/ColorSet';
import { CATEGORY_SET } from '../../../../config/CategorySet'

class MapForReport extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount(){
    let chart = null;
    const data = this.props.data;
    const excelExportFunc = this.props.excelExportFunc;
    const type = this.props.type;
    const reportName = this.props.reportName;

    if(type == "snapshot") {
      this.createMapForSnapshot(chart, reportName, data, excelExportFunc);
    }
    else{
      this.createMapForReport(chart, reportName, data, excelExportFunc);
    }
  }

  componentWillUnmount(){
    if(this.chart) this.chart.dispose();
  }
  
  createMapForSnapshot = (chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.reportMapChart, am4plugins_forceDirected.ForceDirectedTree);
    am4core.useTheme(am4themes_animated);

    let series = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries());
    series.data = JSON.parse(JSON.stringify(dataSet));
    // series.data[0]['children'].splice(5);

    let sumFreq = 0;
    series.data[0]['name'] = `[bold, font-size: 25px]${series.data[0]['name']}[/]`;
    series.data[0]['children'].forEach((item)=>{
      item['name']="[bold]"+item['name']+"[/]";
      item['children'].splice(5);
      sumFreq += item['value'];
    });

    series.data[0]['name-value'] = `${series.data[0]['name']}, [bold, font-size: 25px]${sumFreq}[/]`;

    series.dataFields.value ="value";
    series.dataFields.name = "name";
    series.dataFields.children = "children";

    series.data[0].fixed =  true;
    series.data[0].x= am4core.percent(43);
    series.data[0].y= am4core.percent(50);
    series.dataFields.fixed="fixed";
    series.nodes.template.propertyFields.x = "x";
    series.nodes.template.propertyFields.y = "y";
    series.dataFields.color="am4core.color(color)";

    // Add labels
    series.nodes.template.label.text = "{name}";
    series.nodes.template.label.fontSize = 13;

    series.nodes.template.label.fill = am4core.color("#000000");
    series.nodes.template.tooltipText = "[bold]{name-value}[/]"

    series.minRadius = 18;
    series.maxRadius = 35;
    series.links.template.distance = 1.1;

    let legend = new am4charts.Legend();
    legend.parent = chart.chartContainer;
    legend.background.fillOpacity = 0.05;
    legend.width = 100;
    legend.align = "right";
    legend.paddingLeft = "15px";
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.labels.template.text = "[font-size: 13px]{name}[/]";
    let markerTemplate =  legend.markers.template;
    markerTemplate.width = 13;
    markerTemplate.height = 13;
    CATEGORY_SET.forEach((item)=>{
      legend.data.push({
        "name": item,
        "fill": CATEGORY_COLOR_SET[item]
      })
    })

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("map-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    this.chart = chart;
  }

  createMapForReport = (chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.reportMapChart, am4plugins_forceDirected.ForceDirectedTree);
    am4core.useTheme(am4themes_animated);

    let series = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries());
    series.data = JSON.parse(JSON.stringify(dataSet));
    // series.data[0]['children'].splice(5);

    let sumFreq = 0;
    series.data[0]['name'] = `[bold, font-size: 25px]${series.data[0]['name']}[/]`;
    series.data[0]['children'].forEach((item)=>{
      item['name']="[bold]"+item['name']+"[/]";
      item['children'].splice(5);
      sumFreq += item['value'];
    });

    series.data[0]['name-value'] = `${series.data[0]['name']}, [bold, font-size: 25px]${sumFreq}[/]`;

    series.dataFields.value ="value";
    series.dataFields.name = "name";
    series.dataFields.children = "children";

    series.data[0].fixed =  true;
    series.data[0].x= am4core.percent(43);
    series.data[0].y= am4core.percent(50);
    series.dataFields.fixed="fixed";
    series.nodes.template.propertyFields.x = "x";
    series.nodes.template.propertyFields.y = "y";
    series.dataFields.color="am4core.color(color)";

    // Add labels
    series.nodes.template.label.text = "{name}";
    series.nodes.template.label.fontSize = 13;

    series.nodes.template.label.fill = am4core.color("#000000");
    series.nodes.template.tooltipText = "[bold]{name-value}[/]"

    series.minRadius = 35;
    series.maxRadius = 50;
    series.links.template.distance = 1.2;

    let legend = new am4charts.Legend();
    legend.parent = chart.chartContainer;
    legend.background.fillOpacity = 0.05;
    legend.width = 100;
    legend.align = "right";
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.labels.template.text = "[font-size: 13px]{name}[/]";
    let markerTemplate =  legend.markers.template;
    markerTemplate.width = 13;
    markerTemplate.height = 13;
    CATEGORY_SET.forEach((item)=>{
      legend.data.push({
        "name": item,
        "fill": CATEGORY_COLOR_SET[item]
      })
    })

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("map-export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    this.chart = chart;
  }

  render() {
    return(
      <div>
        <div id="map-export-container" style={{position:"relative", minHeight:"30px"}}/>
        <div id="report-map" ref={ref=>(this.reportMapChart=ref)} style={{ width: this.props.width, height: this.props.height }}></div>
      </div>
    )
  }
}

export default MapForReport;